import React, { Component } from "react";
import {
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    Box,
    CircularProgress,
    Chip
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import BoltIcon from '@mui/icons-material/Bolt';
import BuildIcon from '@mui/icons-material/Build';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import ComputerIcon from '@mui/icons-material/Computer';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PeopleIcon from '@mui/icons-material/People';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { isAuthenticated } from "../auth";
import { listGroups } from "./apigroup";
import Footer from '../core/Footer';

class Groups extends Component {
    constructor(props) {
        super(props);
        const auth = isAuthenticated();

        this.state = {
            groups : [],
            userId : auth && auth.userId,
            token  : auth && auth.token,
            userEmail : auth && auth.email,
            loading : false
        };
    }

    handleChange = name => event => {
        let value = event.target.value
        this.setState({ [name]: value });
    };

    loadGroups = () => {
        this.setState({loading: true })
        listGroups(this.state.token).then(data => {
            if (data.error) {
                console.log(data.error);
                this.setState({ loading: false });
            } else {
                this.setState({
                    groups: data,
                    loading: false
                });
            }
        });
    };

    componentDidMount() {
        this.loadGroups();
    }

    getCommitteeIcon(groupName) {
        const name = groupName.toLowerCase();
        if (name.includes('electrical')) return <BoltIcon sx={{ fontSize: 40 }} />;
        if (name.includes('physical')) return <BuildIcon sx={{ fontSize: 40 }} />;
        if (name.includes('civil') || name.includes('structural')) return <ArchitectureIcon sx={{ fontSize: 40 }} />;
        if (name.includes('technology') || name.includes('tech')) return <ComputerIcon sx={{ fontSize: 40 }} />;
        if (name.includes('business') || name.includes('strategy')) return <BusinessCenterIcon sx={{ fontSize: 40 }} />;
        if (name.includes('innovation')) return <LightbulbIcon sx={{ fontSize: 40 }} />;
        return <PeopleIcon sx={{ fontSize: 40 }} />;
    }

    getCommitteeColor(groupName) {
        const name = groupName.toLowerCase();
        if (name.includes('electrical')) return '#003E7E';
        if (name.includes('physical')) return '#003E7E';
        if (name.includes('civil') || name.includes('structural')) return '#FF6600';
        if (name.includes('technology') || name.includes('tech')) return '#FF6600';
        if (name.includes('business') || name.includes('strategy')) return '#003E7E';
        if (name.includes('innovation')) return '#FF6600';
        return '#003E7E';
    }

    verifyAccess(members, groupId, userId) {
        const isPublic = groupId === '5e971eab6d698b2e84041439';
        const isMember = members.includes(userId);

        if (isPublic) {
            return {
                isMember: true,
                button: (
                    <Button
                        href={`/singlegroup/${groupId}`}
                        variant="contained"
                        endIcon={<CheckCircleIcon />}
                        fullWidth
                        sx={{
                            backgroundColor: '#4caf50',
                            '&:hover': {
                                backgroundColor: '#388e3c',
                            }
                        }}
                    >
                        View Group
                    </Button>
                )
            };
        }

        if (isMember) {
            return {
                isMember: true,
                button: (
                    <Button
                        href={`/singlegroup/${groupId}`}
                        variant="contained"
                        endIcon={<CheckCircleIcon />}
                        fullWidth
                        sx={{
                            backgroundColor: '#4caf50',
                            '&:hover': {
                                backgroundColor: '#388e3c',
                            }
                        }}
                    >
                        View Group
                    </Button>
                )
            };
        }

        return {
            isMember: false,
            button: (
                <Button
                    href={`/group/requestaccess/${groupId}`}
                    variant="outlined"
                    endIcon={<LockOpenIcon />}
                    fullWidth
                    sx={{
                        borderColor: '#003E7E',
                        color: '#003E7E',
                        '&:hover': {
                            borderColor: '#003E7E',
                            backgroundColor: 'rgba(0, 62, 126, 0.1)',
                        }
                    }}
                >
                    Request to Join
                </Button>
            )
        };
    }

    render = () => {
        const { groups, loading, userId } = this.state;

        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 6, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <GroupsIcon sx={{ fontSize: 64 }} />
                            <Box>
                                <Typography variant="h2" component="h1" sx={{ fontWeight: 700 }}>
                                    Committees
                                </Typography>
                                <Typography variant="h5" sx={{ opacity: 0.9 }}>
                                    Join a committee and collaborate with industry peers
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ mb: 6 }}>
                    {/* Loading State */}
                    {loading && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                            <CircularProgress size={60} sx={{ color: '#003E7E' }} />
                        </Box>
                    )}

                    {/* Committees Grid */}
                    {!loading && groups.length > 0 && (
                        <>
                            <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E', mb: 4 }}>
                                Available Committees
                            </Typography>
                            <Grid container spacing={3}>
                                {groups.map((group, i) => {
                                    const access = this.verifyAccess(group.members, group._id, userId);
                                    const color = this.getCommitteeColor(group.name);
                                    const icon = this.getCommitteeIcon(group.name);

                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={i}>
                                            <Card
                                                elevation={3}
                                                sx={{
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderRadius: 3,
                                                    transition: 'all 0.3s ease',
                                                    position: 'relative',
                                                    overflow: 'visible',
                                                    '&:hover': {
                                                        transform: 'translateY(-8px)',
                                                        boxShadow: `0 12px 24px ${color}40`,
                                                    }
                                                }}
                                            >
                                                {/* Member Badge */}
                                                {access.isMember && (
                                                    <Chip
                                                        label="Member"
                                                        size="small"
                                                        icon={<CheckCircleIcon sx={{ fontSize: 16, color: 'white !important' }} />}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 16,
                                                            right: 16,
                                                            backgroundColor: '#4caf50',
                                                            color: 'white',
                                                            fontWeight: 600,
                                                            zIndex: 1
                                                        }}
                                                    />
                                                )}

                                                {/* Header with Icon */}
                                                <Box
                                                    sx={{
                                                        p: 3,
                                                        backgroundColor: color,
                                                        color: 'white',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        minHeight: 120
                                                    }}
                                                >
                                                    {icon}
                                                </Box>

                                                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                                    <Typography
                                                        variant="h5"
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: '#003E7E',
                                                            mb: 2,
                                                            lineHeight: 1.3
                                                        }}
                                                    >
                                                        {group.name}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                        sx={{
                                                            mb: 3,
                                                            lineHeight: 1.6,
                                                            minHeight: 60
                                                        }}
                                                    >
                                                        {group.description}
                                                    </Typography>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                                        <PeopleIcon sx={{ fontSize: 20, color: '#666' }} />
                                                        <Typography variant="body2" color="text.secondary">
                                                            {group.members?.length || 0} members
                                                        </Typography>
                                                    </Box>

                                                    {access.button}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </>
                    )}

                    {/* Empty State */}
                    {!loading && groups.length === 0 && (
                        <Box
                            sx={{
                                textAlign: 'center',
                                py: 10
                            }}
                        >
                            <GroupsIcon sx={{ fontSize: 80, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                            <Typography variant="h5" sx={{ color: '#003E7E', mb: 1 }}>
                                No Committees Available
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Check back soon for new committees to join
                            </Typography>
                        </Box>
                    )}
                </Container>

                <Footer />
            </>
        )
    }
}

export default Groups;
